<template>
  <div id="lp-form">
  </div>
</template>

 <script>
  const { get, isEmpty } = require('lodash')
  export default {
    mounted() {
      let url = `https://form.jotform.com/jsform/${this.$route.meta.formId}`
      if (!isEmpty(get(this, '$route.query'))) url += `?${new URLSearchParams(this.$route.query).toString()}`
      let publishForm = document.createElement('script')
      publishForm.src = url
      document.getElementById('lp-form').appendChild(publishForm);
    }
  };
  </script>